// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import { Container, Box, Typography, Grid, Button } from '@mui/material'; // Material-UIのコンポーネント（レイアウト用とUI要素）

/** 
 * ユーザーパスワード変更テンプレート
 * 現在のパスワードを入力し、新しいパスワードに変更するためのUIを提供
 */
const UserPassTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* タイトルは空の状態 */}
            {/* コンテンツの最大幅を`sm`（スモールサイズ）に設定 */}
            <Container maxWidth='sm'>
                {/* メインボックスでフォーム全体を囲む */}
                <Box sx={{ height: '600px', width: '100%', padding: '20px' }}>
                    {/* グリッドレイアウトでコンテンツを中央揃えに配置 */}
                    <Grid 
                        container 
                        alignItems="center" // 垂直方向の中央揃え
                        direction="column" // コンテンツを縦方向に配置
                    >
                        {/* パスワード変更フォームを囲むボックス */}
                        <Box>
                            {/* 現在のパスワード入力フィールド */}
                            <Typography>
                                現在のパスワード
                            </Typography>
                            <input type="password" size={50} /> {/* パスワード入力フィールド */}

                            {/* 新しいパスワード入力フィールド */}
                            <Typography sx={{ paddingTop: '10px' }}>
                                新しいパスワード
                            </Typography>
                            <input type="password" size={50} /> {/* パスワード入力フィールド */}

                            {/* 新しいパスワード確認入力フィールド */}
                            <Typography sx={{ paddingTop: '10px' }}>
                                新しいパスワードの確認
                            </Typography>
                            <input type="password" size={50} /> {/* パスワード入力フィールド */}
                        </Box>

                        {/* 送信ボタン */}
                        <Button variant='outlined' sx={{ marginTop: '20px' }}>
                            送信
                        </Button>
                    </Grid>
                </Box>
            </Container>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserPassTemplate;
